<template>
  <div>
    <div>
      <v-text-field
        label="Title"
        v-model="title"
      />
    </div>

    <dev-mode>
      <event-type-select v-model="eventTypes"/>
    </dev-mode>

    <div>
      <date-range-input v-model="dateRange"
                        label="Event date"
                        :disabled="!isDateRangeEnabled"
                        :from-value-post-processor="setTimeToStartOfDay"
                        :to-value-post-processor="setTimeToEndOfDay"/>
    </div>
    <div>
      <clients-select v-model="clientIds"/>
    </div>

    <div>
      <services-select v-model="serviceIds"/>
      <filter-6xx v-model="serviceIds"/>
    </div>

    <div>
      MetaFilter:
      <v-btn-toggle v-model="metaFilter" row>
        <v-btn flat v-for="metaFilter in availableMetaFilters" :value="metaFilter">
          {{prettifyOption(metaFilter)}}
        </v-btn>
      </v-btn-toggle>
    </div>

    <div>
      Anomalies:
      <v-btn-toggle v-model="caseAnomalies" row>
        <v-btn flat v-for="caseAnomaly in availableCaseAnomalies" :value="caseAnomaly">
          {{prettifyOption(caseAnomaly)}}
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-checkbox v-model="executedPriceOver9000" label="executedPriceOver9000"/>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import _ from 'lodash'
  import {GetFilteredCaseAnomalies, GetFilteredMetaFilters} from '../../services/CaseServiceLogService'
  import EventTypeSelect from '../../components/Sales/case/EventTypeSelect'
  import DateRangeInput from '../../components/Ui/DateRangeInput'
  import DevMode from '../../components/Ui/DevMode'
  import ClientsSelect from '../../components/Ui/mcc/ClientsSelect'
  import ServicesSelect from '../../components/Ui/mcc/ServicesSelect'
  import Filter6xx from "../../components/analytics/Filter6xx";
  import {setTimeToEndOfDay, setTimeToStartOfDay} from '../../helpers/date'

  export default {
    name: 'analytics-filters',
    components: {
      ServicesSelect,
      EventTypeSelect,
      DateRangeInput,
      ClientsSelect,
      Filter6xx,
      DevMode
    },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        analytics: 'analytics'
      }),
      filterMode: {
        get() {
          return this.analytics.filter.filterMode
        },
        set(newValue) {
          this.changeAnalyticsFilter({
            filterMode: newValue
          })
        }
      },
      isDateRangeEnabled() {
        return this.filterMode === 'RequestedAndExecuted'
      },
      title: {
        get() {
          return this.analytics.filter.title
        },
        set(newValue) {
          let modifiedNewValue = newValue;
          if (!modifiedNewValue) { // cast empty string to null
            modifiedNewValue = null
          }
          this.changeAnalyticsFilter({
            title: modifiedNewValue
          })
        }
      },
      eventTypes: {
        get() {
          return this.analytics.filter.events
        },
        set(newValue) {
          this.changeAnalyticsFilter({
            events: newValue
          })
        }
      },
      dateRange: {
        get() {
          return this.analytics.filter.dateRange
        },
        set(newValue) {
          this.changeAnalyticsFilter({
            dateRange: newValue
          })
        }
      },
      clientIds: {
        get() {
          return this.analytics.filter.clientIds
        },
        set(newValue) {
          this.changeAnalyticsFilter({
            clientIds: newValue
          })
        }
      },
      serviceIds: {
        get() {
          return this.analytics.filter.serviceIds
        },
        set(newValue) {
          this.changeAnalyticsFilter({
            serviceIds: newValue
          })
        }
      },
      metaFilter: {
        get() {
          if (this.analytics.filter.metaFilters.length === 0) {
            return null
          }
          return this.analytics.filter.metaFilters[0]
        },
        set(newValue) {
          let newArrayResult = [];
          if (newValue) {
            newArrayResult = [newValue]
          }
          this.changeAnalyticsFilter({
            metaFilters: newArrayResult
          })
        }
      },
      caseAnomalies: {
        get() {
          if (this.analytics.clientFilter.caseAnomalies.length === 0) {
            return null
          }
          return this.analytics.clientFilter.caseAnomalies[0]
        },
        set(newValue) {
          let newArrayResult = [];
          if (newValue) {
            newArrayResult = [newValue]
          }
          this.changeAnalyticsClientFilter({
            caseAnomalies: newArrayResult
          })
        }
      },
      executedPriceOver9000: {
        get() {
          return this.analytics.clientFilter.executedPriceOver9000
        },
        set(newValue) {
          this.changeAnalyticsClientFilter({
            executedPriceOver9000: newValue
          })
        }
      },
      availableMetaFilters() {
        return _.keys(GetFilteredMetaFilters)
      },
      availableCaseAnomalies() {
        return _.keys(GetFilteredCaseAnomalies)
      }
    },
    methods: {
      ...mapActions({
        changeAnalyticsFilter: 'changeAnalyticsFilter',
        changeAnalyticsClientFilter: 'changeAnalyticsClientFilter'
      }),
      prettifyOption(option) {
        return _.snakeCase(option).replace(/_/g, ' ')
      },
      setTimeToStartOfDay(value) {
        return setTimeToStartOfDay(value)
      },
      setTimeToEndOfDay(value) {
        return setTimeToEndOfDay(value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/AnalyticsFilters.vue